__turbopack_context__.v({
  "bg-standard": "editorial-slide-module-scss-module__vVC_JG__bg-standard",
  "bg-subtle": "editorial-slide-module-scss-module__vVC_JG__bg-subtle",
  "image": "editorial-slide-module-scss-module__vVC_JG__image",
  "link": "editorial-slide-module-scss-module__vVC_JG__link",
  "placeholder": "editorial-slide-module-scss-module__vVC_JG__placeholder",
  "slide": "editorial-slide-module-scss-module__vVC_JG__slide",
  "text": "editorial-slide-module-scss-module__vVC_JG__text",
});
